import PropTypes from 'prop-types';
import React from 'react';

const DetectionPage = ({ trisomy, Gly, strepto }) => (
    <div className="page">
        <span>Dépistages</span>
        <div>
            <span>Dépistage de la trisomie 21</span>

            <div>
                <span>Combiné 1er trimestre</span>
                <span>{`Du ${trisomy.first.min} (11 SA)`}</span>
                <span>{`Au ${trisomy.first.max} (13 SA + 6)`}</span>
            </div>
            <div>
                <span>2ème trimestre</span>
                <span>{`Du ${trisomy.second.min} (14 SA)`}</span>
                <span>{`Au ${trisomy.second.max} (18 SA)`}</span>
            </div>
        </div>
        <div>
            <span>Dépistage du diabete gestationnel</span>
            <div>
                <span>Glycèmie à jeun 1er trimestre</span>
            </div>
            <div>
                <span>HGPO 75g</span>
                <span>{`Du ${Gly.min} (24 SA)`}</span>
                <span>{`Au ${Gly.max} (28 SA)`}</span>
            </div>
        </div>
        <div>
            <span>Streptocoque B (Dépistage systèmatique)</span>
            <span>{`Du ${strepto.min} (34 SA)`}</span>
            <span>{`Au ${strepto.max} (38 SA)`}</span>
        </div>
    </div>
);
const minMaxProp = PropTypes.shape({
    min: PropTypes.string.isRequired,
    max: PropTypes.string.isRequired,
});
DetectionPage.propTypes = {
    trisomy: PropTypes.shape({ first: minMaxProp.isRequired, second: minMaxProp.isRequired }).isRequired,
    Gly: minMaxProp.isRequired,
    strepto: minMaxProp.isRequired,
};
export default DetectionPage;
